import React from 'react';
import { useTranslation } from 'react-i18next';

import { ProfileIcon } from 'src/packages/icons';
import { Button, NavLinkWithPopover, NavIconWithPopover } from 'src/packages/core';
import { AssetsPopoverContent } from './AssetsPopoverContent';
import { ProfileIconPopoverContent } from './ProfileIconPopoverContent';
import { HeaderAssets, HeaderUser, KycAndFeaturesConfig } from '../Header.types';
import { ThemeType } from 'src/packages/theme';
import { getOrdersLinks } from 'src/packages/common/header/links';
import { adjustKycAndFeaturesConfig } from 'src/utils/adjust-kyc-and-features-config';
import { goToUrl } from 'src/utils/go-to-url';
import { config } from 'src/config';

interface Props {
  hideRightNav?: boolean;
  assets?: HeaderAssets;
  theme?: ThemeType;
  user?: HeaderUser;
  logout?: () => void;
  copyToClipboard?: (value: string) => void;
  kycAndFeaturesConfig?: KycAndFeaturesConfig;
}

export const HeaderUserButtons = ({
  hideRightNav,
  assets,
  theme = 'dark',
  user,
  logout,
  copyToClipboard,
  kycAndFeaturesConfig,
}: Props) => {
  const { t } = useTranslation();

  const { tradeSpotPlatformEnabled, tradeDerivativesPlatformEnabled, earnPlatformEnabled } =
    adjustKycAndFeaturesConfig(kycAndFeaturesConfig);

  return (
    <>
      {!hideRightNav && (
        <>
          <Button
            theme={'dark'}
            variant={'secondaryMedium'}
            text={t('button.deposit')}
            onClick={() => {
              goToUrl(`${config.coinflareUrl}/assets/spot/deposit`);
            }}
          />

          <NavLinkWithPopover
            title={t('header.menu.assets')}
            mainLink={`${config.coinflareUrl}/assets`}
            popoverCustomContent={<AssetsPopoverContent assets={assets} theme={theme} />}
            theme={theme}
          />

          {!earnPlatformEnabled &&
          !tradeSpotPlatformEnabled &&
          !tradeDerivativesPlatformEnabled ? null : (
            <NavLinkWithPopover
              title={t('header.menu.orders')}
              links={getOrdersLinks(
                earnPlatformEnabled,
                tradeSpotPlatformEnabled,
                tradeDerivativesPlatformEnabled
              )}
              theme={theme}
            />
          )}
        </>
      )}

      <NavIconWithPopover
        icon={ProfileIcon}
        popoverCustomContent={
          <ProfileIconPopoverContent
            theme={theme}
            user={user}
            logout={logout}
            copyToClipboard={copyToClipboard}
          />
        }
        theme={theme}
      />
    </>
  );
};
